"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Chip = void 0;
var react_1 = __importDefault(require("react"));
var constants_1 = require("../../../constants");
var mixpanel_events_1 = require("../../../constants/mixpanel-events");
var index_1 = require("../index");
var Chip = function (_a) {
    var value = _a.value, label = _a.label, _b = _a.closeIcon, closeIcon = _b === void 0 ? null : _b, _c = _a.onClick, onClick = _c === void 0 ? constants_1.defaultFn : _c, _d = _a.onRemoveValue, onRemoveValue = _d === void 0 ? constants_1.defaultFn : _d, _e = _a.className, className = _e === void 0 ? '' : _e, _f = _a.bgClassName, bgClassName = _f === void 0 ? 'tw-bg-BASE_SECONDARY' : _f, id = _a.id, eventCallback = _a.eventCallback;
    var handleRemoveValue = function () {
        onRemoveValue();
        eventCallback === null || eventCallback === void 0 ? void 0 : eventCallback(mixpanel_events_1.mixpanelEvents.CHIP_REMOVE, { id: id, value: value });
    };
    return (react_1.default.createElement("div", { key: value, onClick: onClick, className: "tw-rounded-[28px] tw-h-[35px] tw-flex tw-items-center tw-px-4 " + bgClassName + " " + className, "data-testid": "chip-wrapper-" + id },
        label && (react_1.default.createElement(index_1.Text, { textClass: 'f-12-300', id: "chip-label-" + id }, label)),
        !!closeIcon && (react_1.default.createElement("div", { id: "" + value, onClick: handleRemoveValue, className: 'tw-ml-2.5', "data-testid": "chip-close-icon-wrapper-" + id }, closeIcon))));
};
exports.Chip = Chip;
